export default __webpack_public_path__ + "static/media/tick.40d784d9.svg";